import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export const InfoFaceIcon = (props: IconProps = {}): JSX.Element => {
  const { ...rest } = props;

  return (
    <SvgIcon name="InfoFace" {...rest}>
      <path
        d="M34.3 5L39 9.7V43H9V5H34.3ZM35.5 2H6V46H42V8.5L35.5 2Z"
        fill="black"
      />
      <path
        d="M16 23C17.1046 23 18 22.1046 18 21C18 19.8954 17.1046 19 16 19C14.8954 19 14 19.8954 14 21C14 22.1046 14.8954 23 16 23Z"
        fill="black"
      />
      <path
        d="M32 23C33.1046 23 34 22.1046 34 21C34 19.8954 33.1046 19 32 19C30.8954 19 30 19.8954 30 21C30 22.1046 30.8954 23 32 23Z"
        fill="black"
      />
      <path
        d="M28.5 30H19.5C18.7 30 18 29.3 18 28.5C18 27.7 18.7 27 19.5 27H28.5C29.3 27 30 27.7 30 28.5C30 29.3 29.3 30 28.5 30Z"
        fill="black"
      />
    </SvgIcon>
  );
};
